export const ERROR_DUPLICATE_PROFILE = 'DUPLICATE_PROFILE';
export const ERROR_DEFAULT = 'default';
export const ERROR_HOST_NOT_FOUND = 'HOST_NOT_FOUND';
export const ERROR_BAD_INTEGRATION_CONFIGURATION = 'BAD_INTEGRATION_CONFIGURATION';

export const UNAUTHORIZED_ERROR_CODE = 401;
export const NOT_FOUND_ERROR_CODE = 404;
export const BAD_REQUEST_ERROR_CODE = 400;
export const INTERNAL_SERVER_ERROR_CODE = 500;
